import { render } from "./PaidIcon.vue?vue&type=template&id=601a686a&scoped=true"
import script from "./PaidIcon.vue?vue&type=script&lang=js"
export * from "./PaidIcon.vue?vue&type=script&lang=js"

import "./PaidIcon.vue?vue&type=style&index=0&id=601a686a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601a686a"]])

export default __exports__